import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const toolsStateExportPdfIsActiveSelector = (state: AppState) => state.map.mapSettings.data.toolsState.exportPdf.isActive;
export const useToolsStateExportPdfIsActiveSelector = () => useSelector(toolsStateExportPdfIsActiveSelector);
